import {Form as AntdForm} from 'antd';

const FormItem = (props) => (
  <AntdForm.Item {...props}/>
);

export default FormItem;
